import { Logger } from 'src/utils/Logger';

const INVITE_EMAIL_KEY = 'afternoon_invite_email';
const INVITE_TENANT_KEY = 'afternoon_invite_tenant';
const INVITE_TIMESTAMP_KEY = 'afternoon_invite_timestamp';
const TTL_MS = 5 * 60 * 1000; // 5 minutes

interface InviteData {
  email: string;
  tenantName: string;
}

export const setInviteData = (email: string, tenantName: string): void => {
  try {
    sessionStorage.setItem(INVITE_EMAIL_KEY, email);
    sessionStorage.setItem(INVITE_TENANT_KEY, tenantName);
    sessionStorage.setItem(INVITE_TIMESTAMP_KEY, Date.now().toString());
  } catch (e) {
    Logger.error('sessionStorage unavailable for invite data', e);
  }
};

export const getInviteData = (): InviteData | null => {
  try {
    const email = sessionStorage.getItem(INVITE_EMAIL_KEY);
    const tenantName = sessionStorage.getItem(INVITE_TENANT_KEY);
    const timestamp = sessionStorage.getItem(INVITE_TIMESTAMP_KEY);

    if (!email || !tenantName || !timestamp) return null;

    if (Date.now() - parseInt(timestamp, 10) > TTL_MS) {
      clearInviteData();
      return null;
    }
    return { email, tenantName };
  } catch {
    return null;
  }
};

export const clearInviteData = (): void => {
  try {
    sessionStorage.removeItem(INVITE_EMAIL_KEY);
    sessionStorage.removeItem(INVITE_TENANT_KEY);
    sessionStorage.removeItem(INVITE_TIMESTAMP_KEY);
  } catch (e) {
    Logger.error('sessionStorage unavailable for clearing invite data', e);
  }
};
